<template>
	<div :id="id" class="partner-content-block">
		<DefaultIcon
			v-if="logo"
			:logo="logo"
			class="partner-content-block__logo"
		></DefaultIcon>
		<p v-if="title" class="partner-content-block__title">{{ title }}</p>
		<div
			v-if="description"
			v-html="description"
			class="partner-content-block__description"
		/>
		<PartnerContentItem
			v-for="item in items"
			:key="item.id"
			:fields="item.fields"
		></PartnerContentItem>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const id = computed(() => props.fields?.id?.value);
const logo = computed(() =>
	props.fields?.logo?.value?.src ? props.fields?.logo?.value : null
);
const title = computed(() => props.fields?.title?.value);
const description = computed(() => props.fields?.description?.value);
const items = computed(() => props.fields?.items || []);
</script>

<style lang="scss">
.partner-content-block {
	display: flex;
	width: 100%;
	padding: var(--spacing-5, 40px) var(--spacing-2, 16px);
	flex-direction: column;
	align-items: flex-start;
	background: #282828;

	.partner-content-block__title {
		font-size: var(--text-2xl, 32px);
		font-weight: 300;
		line-height: 120%;
		color: var(--color-white, #fff);
		margin: var(--spacing-3, 24px) 0;
	}

	.partner-content-block__logo,
	.partner-content-block__logo img {
		width: 100%;
		height: 100%;
	}

	.partner-content-block__description {
		margin: 0;
	}

	p {
		font-size: var(--text-base, 16px);
		color: var(--color-grey-3, #989898);
	}
}
</style>
